import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { DAILY_OPTION } from "../../../../constants/notification-key";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { MultiSelectOption } from "../../../../models/MultiSelectOption";
import { validateNumberOfDays, validateRecurrenceFrequency } from "../../../../utilities/Validation";
import Label from "../../../label/label";

const Daily: FC = () => {
    const { translate } = useLocale();
    const { errors, setFieldValue, values } = useFormikContext<any>();

    const dailyOptions: MultiSelectOption[] = [
        { value: DAILY_OPTION.EVERY, label: translate.byKey(TranslationKeys.every) },
        { value: DAILY_OPTION.EVERY_WEEKDAY, label: translate.byKey(TranslationKeys.everyWeekday) }
    ];

    const onDailyOptionsChanged = (option: MultiSelectOption) => {
        setFieldValue("dailyOption", option.value);
    }

    return <div className="flex flex-row">
        <div className="flex flex-col">
            {dailyOptions.map((option) => (
                <div
                    key={option.value}
                    className="flex items-center text-sm font-medium ">
                    <Field
                        id={`radio-${option.value}`}
                        type="radio"
                        name="dailyOption"
                        value={option.value}
                        validate={(value) => validateRecurrenceFrequency(value, translate)}
                        onChange={(_: any) => onDailyOptionsChanged(option)} />
                    <Label htmlFor={`radio-${option.value}`} className="pl-1 text-sm">{option.label}</Label>
                </div>
            ))}
        </div>

        <div className="px-5" >
            <div className="flex flex-row justify-between">
                <Field
                    name="occurrences"
                    valueName="occurrences"
                    type="text"
                    validate={(value) => values.dailyOption === DAILY_OPTION.EVERY && validateNumberOfDays(value, translate)}
                    disabled={values.dailyOption !== DAILY_OPTION.EVERY}
                    className={`p-1 text-sm w-16 h-6 bg-gray-input overflow-hidden ml-1 ${values.dailyOption !== DAILY_OPTION.EVERY ? 'text-gray-500 cursor-not-allowed' : ''}`} />
                <span className="px-3">{translate.byKey(TranslationKeys.dayDays).toLowerCase()}</span>
            </div>
        </div>
    </div>
}

export default Daily;